import { Component, inject, Input, OnInit } from '@angular/core';
import { Toast, ToastType } from '../../services/toasts/toast.model';
import { TranslateModule } from '@ngx-translate/core';
import { JsonPipe } from '@angular/common';
import { CoreModule } from '@toevla-webapplications/core';
import { ToastsService } from '../../services/toasts/toasts.service';

@Component({
    selector: 'ivva-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    imports: [TranslateModule, JsonPipe, CoreModule]
})
export class ToastComponent implements OnInit {
	@Input()
	toast: Toast;

	readonly ToastType = ToastType;

	private readonly toastsService = inject(ToastsService);

	ngOnInit() {
		const seconds = this.toast.type === ToastType.ERROR ? 5 : 3;
		const time = seconds * 1_000;
		setTimeout(() => this.close(), time);
	}

	close() {
		this.toastsService.remove(this.toast.id);
	}
}
